var _style, _g, _path, _path2, _line, _line2, _path3, _path4, _path5, _line3, _line4, _path6, _circle, _circle2, _circle3, _circle4, _path7, _line5, _path8, _line6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPosNegBarNeutral(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 520 50",
    style: {
      enableBackground: "new 0 0 520 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M497,15.6v22.8H23V15.6H497 M500,13H20v28h480V13L500,13z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M500,9.7c16.7,0,16.7,10.4,16.7,16.7S516.7,43,500,43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M260,43h240V9.7c0,0-161.8,0-240-6V43z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 306.3,
    y1: 6.3,
    x2: 260,
    y2: 10.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 260,
    y1: 10.2,
    x2: 273.4,
    y2: 4.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M500,43c0,0-140,0-240,4.4h0V43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20,9.7C3.3,9.7,3.3,20.1,3.3,26.4S3.3,43,20,43"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M260,43H20V9.7c0,0,161.8,0,240-6V43z"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 213.7,
    y1: 6.3,
    x2: 260,
    y2: 10.2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 260,
    y1: 10.2,
    x2: 246.6,
    y2: 4.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20,43c0,0,140,0,240,4.4h0V43"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 13.2,
    cy: 19.4,
    r: 3.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 13.2,
    cy: 34.6,
    r: 3.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 506.2,
    cy: 19.4,
    r: 3.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 506.2,
    cy: 34.6,
    r: 3.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M510,34.6c0,0,0-7.6,2.8-7.6c-2.8,0-2.8-7.6-2.8-7.6"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 502.4,
    y1: 19.4,
    x2: 502.4,
    y2: 34.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.4,34.6c0,0,0-7.6-2.8-7.6c2.8,0,2.8-7.6,2.8-7.6"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 17,
    y1: 19.4,
    x2: 17,
    y2: 34.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosNegBarNeutral);
export default __webpack_public_path__ + "static/media/pos_neg_bar_neutral.fac4c0d6aeceae25014f1c717025a9c9.svg";
export { ForwardRef as ReactComponent };